import React from 'react';
import { ReactComponent as TickInsideCircle } from '../../assets/custom/icons/tick_inside_circle.svg';
import { ReactComponent as SignOut } from '../../assets/custom/icons/sign_out.svg';
import { ReactComponent as Tick } from '../../assets/custom/icons/tick.svg';
import translate from '@data/translations';
import { ReservationGuestBoards } from './reservationGuestBoards';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

const SidebarDailyInfo = (props) => {
    return (
        <React.Fragment>
            <div
                className="sidebarDailyInfo mt-3"
                style={{
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 8px 20px rgba(105, 119, 140, 0.15)',
                }}
            >
                <div
                    className="mt-2"
                    style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        left: '24px',
                        position: 'relative',
                        color: '#00112B',
                    }}
                >
                    {translate('Current situation')}
                </div>
                <div className="mt-2" style={{ position: 'relative' }}>
                    <AvailableRoomsTakenRooms {...props} />
                </div>
                <div style={{ position: 'relative' }}>
                    <CurrentGuestNumber2 {...props} />
                </div>
            </div>

            <div
                className="sidebarDailyInfo"
                style={{
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 8px 20px rgba(105, 119, 140, 0.15)',
                }}
            >
                <div
                    className="mt-2"
                    style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        left: '24px',
                        position: 'relative',
                        color: '#00112B',
                    }}
                >
                    {translate('Today')}
                </div>
                <div className="mt-2">
                    <HotelOccupancy2 {...props} from={dayjs().startOf('day')} to={dayjs().endOf('day')} />
                </div>
                <div>
                    <CheckinsRoomsCheckinsGuests {...props} from={dayjs().startOf('day')} to={dayjs().endOf('day')} />
                </div>
                <div>
                    <CheckoutsRoomsCheckoutsGuests {...props} from={dayjs().startOf('day')} to={dayjs().endOf('day')} />
                </div>
                <div>
                    <ReservationGuestBoards
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().endOf('day')}
                        period={'Today'}
                    />
                </div>
            </div>

            <div
                className="sidebarDailyInfo"
                style={{
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 8px 20px rgba(105, 119, 140, 0.15)',
                }}
            >
                <div
                    className="mt-2"
                    style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        left: '24px',
                        position: 'relative',
                        color: '#00112B',
                    }}
                >
                    {translate('Tomorrow')}
                </div>
                <div className="mt-2">
                    <HotelOccupancy2
                        {...props}
                        from={dayjs().add(1, 'days').startOf('day')}
                        to={dayjs().add(1, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <CheckinsRoomsCheckinsGuests
                        {...props}
                        from={dayjs().add(1, 'days').startOf('day')}
                        to={dayjs().add(1, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <CheckoutsRoomsCheckoutsGuests
                        {...props}
                        from={dayjs().add(1, 'days').startOf('day')}
                        to={dayjs().add(1, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <ReservationGuestBoards
                        {...props}
                        from={dayjs().add(1, 'days').startOf('day')}
                        to={dayjs().add(1, 'days').endOf('day')}
                        period={'Tomorow'}
                    />
                </div>
            </div>

            <div
                className="sidebarDailyInfo"
                style={{
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 8px 20px rgba(105, 119, 140, 0.15)',
                }}
            >
                <div
                    className="mt-2"
                    style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        left: '24px',
                        position: 'relative',
                        color: '#00112B',
                    }}
                >
                    {translate('Next 15 days')}
                </div>
                <div className="mt-2">
                    <HotelOccupancy2
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(14, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <CheckinsRoomsCheckinsGuests
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(14, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <CheckoutsRoomsCheckoutsGuests
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(14, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <ReservationGuestBoards
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(14, 'days').endOf('day')}
                        period={'15 days'}
                    />
                </div>
            </div>

            <div
                className="sidebarDailyInfo"
                style={{
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 8px 20px rgba(105, 119, 140, 0.15)',
                }}
            >
                <div
                    className="mt-2"
                    style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        left: '24px',
                        position: 'relative',
                        color: '#00112B',
                    }}
                >
                    {translate('Next 30 days')}
                </div>
                <div className="mt-2">
                    <HotelOccupancy2
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(29, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <CheckinsRoomsCheckinsGuests
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(29, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <CheckoutsRoomsCheckoutsGuests
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(29, 'days').endOf('day')}
                    />
                </div>
                <div>
                    <ReservationGuestBoards
                        {...props}
                        from={dayjs().startOf('day')}
                        to={dayjs().add(29, 'days').endOf('day')}
                        period={'Month'}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};
export default SidebarDailyInfo;

const CheckinsRooms = ({ reservations, from, to }) => {
    const checkins = reservations.filter(
        (r) => (r.statusEnum === 1 || r.statusEnum === 2) && dayjs(r.checkInTimestamp).isBetween(from, to, null, '[]')
    );

    return (
        <div className="col-6">
            <div className="pl-3 pr-3">
                <small>
                    {translate('Rooms')}: {checkins.length}
                </small>
            </div>
        </div>
    );
};

const CheckinsGuests = ({ reservations, from, to }) => {
    const checkins = reservations.filter(
        (r) => (r.statusEnum === 1 || r.statusEnum === 2) && dayjs(r.checkInTimestamp).isBetween(from, to, null, '[]')
    );
    const adultsNumberIncoming = checkins.reduce((sum, a) => {
        return sum + Number(a.adultsNumber);
    }, 0);
    const childrenNumberIncoming = checkins.reduce((sum, a) => {
        return sum + Number(a.childrenNumber);
    }, 0);

    const totalGuestsIncoming = adultsNumberIncoming + childrenNumberIncoming;

    return (
        <div className="col-6">
            <div className="pl-3 pr-3">
                <small>
                    {translate('Guests')}: {totalGuestsIncoming}
                </small>
            </div>
        </div>
    );
};

const CheckoutsGuests = ({ reservations, from, to }) => {
    const checkouts = reservations.filter(
        (r) => (r.statusEnum === 1 || r.statusEnum === 2) && dayjs(r.checkOutTimestamp).isBetween(from, to, null, '[]')
    );
    const adultsNumberOngoing = checkouts.reduce((sum, a) => {
        return sum + Number(a.adultsNumber);
    }, 0);
    const childrenNumberOngoing = checkouts.reduce((sum, a) => {
        return sum + Number(a.childrenNumber);
    }, 0);

    const totalGuestsOngoing = adultsNumberOngoing + childrenNumberOngoing;
    return (
        <div className="col-6">
            <div className="pl-3 pr-3">
                <small>
                    {translate('Guests')}: {totalGuestsOngoing}
                </small>
            </div>
        </div>
    );
};

const CheckoutsRooms = ({ reservations, from, to }) => {
    const checkouts = reservations.filter(
        (r) => (r.statusEnum === 1 || r.statusEnum === 2) && dayjs(r.checkOutTimestamp).isBetween(from, to, null, '[]')
    );
    return (
        <div className="col-6">
            <div className="pl-3 pr-3">
                <small>
                    {translate('Rooms')}: {checkouts.length}
                </small>
            </div>
        </div>
    );
};

const IncomingsDeparturesHeader = () => {
    return (
        <div className=" text-center p-0  mt-1 d-flex">
            <div className="primary-bg-1 text-white col-6 border-radius-4">
                <small>
                    <b>{translate('Incomings')}</b>
                </small>
            </div>
            <div className="primary-bg-7 text-white col-6 border-radius-4">
                <small>
                    <b>{translate('Departures')}</b>
                </small>
            </div>
        </div>
    );
};

const HotelOccupancy = ({ from, to, reservations, rooms }) => {
    const numberOfRooms = rooms.length;
    const maxHotelOccupancyDays = dayjs(to).diff(dayjs(from), 'days') + 1;
    const maxCapacity = maxHotelOccupancyDays * numberOfRooms;

    const filteredReservations = reservations.filter((r) => r.statusEnum === 1 || r.statusEnum === 2);

    const daysTakenRangesArr = [];

    for (const reservation of filteredReservations) {
        let checkIn = dayjs(reservation.checkInTimestamp);
        let checkOut = dayjs(reservation.checkOutTimestamp);

        // Ako je checkOut isti dan kao 'to', smanji za jedan dan (kao u originalnom kodu)
        if (checkOut.isSame(dayjs(to), 'day')) {
            checkOut = checkOut.subtract(1, 'day');
        }

        // Provjeri preklapanje intervala (rezervacija i traženog perioda)
        // Intervali se preklapaju ako:
        // checkIn <= to && checkOut >= from
        if (checkIn.isSameOrBefore(dayjs(to)) && checkOut.isSameOrAfter(dayjs(from))) {
            // Izračunaj zajednički interval (preklapanje)
            const start = checkIn.isAfter(dayjs(from)) ? checkIn : dayjs(from);
            const end = checkOut.isBefore(dayjs(to)) ? checkOut : dayjs(to);

            daysTakenRangesArr.push({ start, end });
        }
    }

    let daysTaken = 0;

    for (const range of daysTakenRangesArr) {
        daysTaken += range.end.diff(range.start, 'days') + 1;
    }

    return (
        <React.Fragment>
            <div className=" text-center menu-item-selected border-radius-4 font-16" style={{ padding: '4px' }}>
                <small>
                    <b>{translate('Potential hotel occupancy')}</b>
                </small>
            </div>
            <div className=" p-0">
                <div className="d-flex justify-content-between">
                    <div className="p-2">
                        <small>
                            {translate('Days')}: {daysTaken}
                        </small>
                    </div>
                    <div className="p-2">
                        <small>
                            {translate('Percentage')}: {parseFloat((daysTaken * 100) / maxCapacity).toFixed(2)}%
                        </small>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const CheckinsRoomsCheckinsGuests = ({ reservations, from, to }) => {
    const checkins = reservations.filter(
        (r) => (r.statusEnum === 1 || r.statusEnum === 2) && dayjs(r.checkInTimestamp).isBetween(from, to, null, '[]')
    );

    const adultsNumberIncoming = checkins.reduce((sum, a) => {
        return sum + Number(a.adultsNumber);
   }, 0);
    const childrenNumberIncoming =checkins.reduce((sum, a) => {
        return sum + Number(a.childrenNumber);
   }, 0);

    const totalGuestsIncoming = adultsNumberIncoming + childrenNumberIncoming;

    return (
        <div className="display-flex align-items-center mt-2">
            <div
                className="color-primary mt-1 ml-4"
                style={{
                    height: '40px',
                    width: '40px',
                    borderRadius: '80px',
                    padding: '4px',
                    backgroundColor: '#DBE8FC',
                }}
            >
                <TickInsideCircle />
            </div>
            <div className="ml-16p">
                <div style={{ fontWeight: '700', fontSize: '20px' }}>
                    {checkins.length} / {totalGuestsIncoming}
                </div>
                <div style={{ fontWeight: '400', fontSize: '12px', color: '#69778C' }}>
                    {translate('rooms / guests incoming')}
                </div>
            </div>
        </div>
    );
};

const CheckoutsRoomsCheckoutsGuests = ({ reservations, from, to }) => {
    const checkouts = reservations.filter(
        (r) => (r.statusEnum === 1 || r.statusEnum === 2) && dayjs(r.checkOutTimestamp).isBetween(from, to, null, '[]')
    );

    const adultsNumberOngoing = checkouts.reduce((sum, a) => {
        return sum + Number(a.adultsNumber);
   }, 0);
    const childrenNumberOngoing = checkouts.reduce((sum, a) => {
        return sum + Number(a.childrenNumber);
   }, 0);

    const totalGuestsOngoing = adultsNumberOngoing + childrenNumberOngoing;

    return (
        <div className="display-flex align-items-center mt-2">
            <div
                className="color-dark mt-1 ml-4"
                style={{
                    height: '40px',
                    width: '40px',
                    borderRadius: '80px',
                    padding: '4px',
                    backgroundColor: '#F3F6FB',
                }}
            >
                <SignOut />
            </div>
            <div className="ml-16p">
                <div style={{ fontWeight: '700', fontSize: '20px' }}>
                    {checkouts.length} / {totalGuestsOngoing}
                </div>
                <div style={{ fontWeight: '400', fontSize: '12px', color: '#69778C' }}>
                    {translate('rooms / guests outgoing')}
                </div>
            </div>
        </div>
    );
};

const CurrentGuestNumber2 = ({ reservations }) => {
    const allCheckedInReservations = reservations.filter((r) => r.statusEnum === 2);
    const adultsNumber = allCheckedInReservations.reduce((sum, a) => {
        return sum + Number(a.adultsNumber);
    }, 0);
    const childrenNumber = allCheckedInReservations.reduce((sum, a) => {
        return sum + Number(a.childrenNumber);
    }, 0);

    const totalGuests = adultsNumber + childrenNumber;
    return (
        <div className="display-flex align-items-center mt-2">
            <div
                className="color-white mt-1 ml-4"
                style={{
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    backgroundColor: totalGuests > 0 ? '#1068EC' : '#DBE8FC',
                    transform: 'scale(1)',
                }}
            >
                <Tick height={'50'} width={'50'} />
            </div>
            <div className="ml-16p">
                <div style={{ fontWeight: '700', fontSize: '26px' }}>{totalGuests}</div>
                <div style={{ fontWeight: '400', fontSize: '12px', color: '#69778C' }}>
                    {translate('guests currently checked in')}
                </div>
            </div>
        </div>
    );
};

const AvailableRoomsTakenRooms = ({ reservations, rooms }) => {
    const takenRoomInfoIds = [];
    for (const reservation of reservations) {
        if (reservation.statusEnum === 2) {
            takenRoomInfoIds.push(reservation.roomInfoId);
        }
    }
    const roomsTaken = rooms.filter((r) => takenRoomInfoIds.includes(r.id));

    return (
        <div className="display-flex align-items-center">
            <div className="mt-1 ml-4" style={{ height: '50px', width: '50px' }}>
                <Pie
                    percentage={parseFloat((roomsTaken.length / rooms.length) * 100).toFixed(2)}
                    colour={'#1068EC'}
                    width4050={50}
                    heigth4050={50}
                    radius={20}
                    cx={175}
                    cy={25}
                    strokeWidth={'10px'}
                />
            </div>

            <div className="ml-16p">
                <div style={{ fontWeight: '700', fontSize: '26px' }}>
                    {parseFloat((roomsTaken.length / rooms.length) * 100).toFixed(2)}%
                </div>
                <div
                    style={{
                        fontWeight: '400',
                        fontSize: '12px',
                        color: '#69778C',
                    }}
                >
                    {roomsTaken.length}/{rooms.length} {translate('rooms occupied')}
                </div>
            </div>
        </div>
    );
};

const Circle = ({ colour, percentage, radius, cx, cy, strokeWidth }) => {
    const r = radius;
    const circ = 2 * Math.PI * r;
    const strokePct = ((100 - percentage) * circ) / 100; // where stroke will start, e.g. from 15% to 100%.
    return (
        <circle
            r={r}
            cx={cx}
            cy={cy}
            fill="transparent"
            stroke={strokePct.toFixed(2) !== circ.toFixed(2) ? colour : ''} // remove colour as 0% sets full circumference
            strokeWidth={strokeWidth}
            strokeDasharray={circ}
            strokeDashoffset={percentage ? strokePct : 0}
        ></circle>
    );
};

const cleanPercentage = (percentage) => {
    const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0; // we can set non-numbers to 0 here
    const isTooHigh = percentage > 100;
    return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
};

const Pie = ({ percentage, colour, width4050, heigth4050, radius, cx, cy, strokeWidth }) => {
    const pct = cleanPercentage(percentage);
    return (
        <svg width={width4050} height={heigth4050}>
            <g transform={`rotate(-90 ${'100 100'})`}>
                <Circle colour="#DBE8FC" radius={radius} cx={cx} cy={cy} strokeWidth={strokeWidth} />
                <Circle colour={colour} percentage={pct} radius={radius} cx={cx} cy={cy} strokeWidth={strokeWidth} />
            </g>
        </svg>
    );
};

const HotelOccupancy2 = ({ from, to, reservations, rooms }) => {
    const numberOfRooms = rooms.length;
    // Pretvori from i to u dayjs objekte
    const startRange = dayjs(from);
    const endRange = dayjs(to);

    const maxHotelOccupancyDays = endRange.diff(startRange, 'days') + 1;
    const maxCapacity = maxHotelOccupancyDays * numberOfRooms;

    const range = { start: startRange, end: endRange };

    const filteredReservations = reservations.filter((r) => r.statusEnum === 1 || r.statusEnum === 2);

    const daysTakenRangesArr = [];

    for (const reservation of filteredReservations) {
        let resStart = dayjs(reservation.checkInTimestamp);
        let resEnd = dayjs(reservation.checkOutTimestamp);

        if (resEnd.isSame(range.end, 'day')) {
            resEnd = resEnd.subtract(1, 'day');
        }

        const isOverlapping = resStart.isSameOrBefore(range.end) && resEnd.isSameOrAfter(range.start);

        if (isOverlapping) {
            const overlapStart = resStart.isAfter(range.start) ? resStart : range.start;
            const overlapEnd = resEnd.isBefore(range.end) ? resEnd : range.end;
            daysTakenRangesArr.push({ start: overlapStart, end: overlapEnd });
        }
    }

    let daysTaken = 0;
    for (const r of daysTakenRangesArr) {
        daysTaken += r.end.diff(r.start, 'days') + 1;
    }

    return (
        <React.Fragment>
            <div className="display-flex align-items-center mt-2">
                <div style={{ height: '40px', width: '40px' }} className="mt-1 ml-4">
                    <Pie
                        percentage={parseFloat((daysTaken * 100) / maxCapacity).toFixed(2)}
                        colour={'#1068EC'}
                        width4050={40}
                        heigth4050={40}
                        radius={16}
                        cx={180}
                        cy={20}
                        strokeWidth={'7px'}
                    />
                </div>
                <div className="ml-16p">
                    <div style={{ fontWeight: '700', fontSize: '20px' }}>
                        {parseFloat((daysTaken * 100) / maxCapacity).toFixed(2)}% <span style={{ fontSize: '14px', color: '#69778C' }}>({daysTaken}/{maxCapacity})</span>
                    </div>
                    <div
                        style={{
                            fontWeight: '400',
                            fontSize: '12px',
                            color: '#69778C',
                        }}
                    >
                        {translate('potential hotel occupancy')}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export { CheckoutsRooms, CheckoutsGuests, CheckinsGuests, CheckinsRooms, HotelOccupancy, IncomingsDeparturesHeader };
